import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ISystemMessagesApi } from "@/api/system-messages";
import { SERVICES_TYPES, useInjection } from "@/ioc";
import { SystemMessagePayload } from "@/models/system-message";
import { useToast } from "@/hooks/use-toast";

export const useCreateSystemMessage = () => {
  const systemMessagesApi = useInjection<ISystemMessagesApi>(SERVICES_TYPES.SYSTEM_MESSAGES);
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: (payload: SystemMessagePayload) => systemMessagesApi.create(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["system-messages"] });
      toast({ title: "System message created" });
    },
    onError: (error) => {
      toast({
        title: "Failed to create system message",
        description: error.message,
        variant: "destructive"
      });
    }
  });
};
